<template>
  <div class="v-users-iban">
    <b-card class="content-card">
      <div fluid>
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          v-if="!loading"
          :items="results"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(accountInfo)="row">
            <div class="text-right">
              <b-link
                :to="'/user-profile/' + row.item.accountInfo.id"
                size="sm"
                variant="outline-primary"
              >
                {{ row.item.accountInfo.firstName }}
                {{ row.item.accountInfo.lastName }}
              </b-link>
            </div>
          </template>

          <template #cell(status)="row">
            <div class="text-right">
              <b-badge
                v-if="row.value == 'Pending'"
                :variant="row.value == 'Pending' ? 'warning' : 'success'"
              >
                {{ row.value == "Pending" ? "تایید نشده" : "تایید شده" }}
              </b-badge>

              <b-badge v-if="row.value == 'Approved'" variant="success">
                تایید شده </b-badge
              >ّ

              <b-badge v-if="row.value == 'Rejected'" variant="danger">
                رد شده
              </b-badge>
            </div>
          </template>

          <template #cell(actions)="row">
            <div class="d-flex flex-wrap">
              <b-button
                class="mr-1"
                variant="success"
                size="sm"
                @click="verifySheba(row.item.id, row.item.accountInfo.id)"
                v-if="row.item.status != 'Approved'"
              >
                تایید شبا
              </b-button>

              <b-button
                class="mr-1"
                variant="danger"
                size="sm"
                @click="rejectSheba(row.item.id, row.item.accountInfo.id)"
                v-if="row.item.status != 'Rejected'"
              >
                رد شبا
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import http from "@/httpservices/HttpService"

export default {
  name: "UsersIban",
  data() {
    return {
      results: [],
      loading: true,
      token: localStorage.getItem("token") || "",

      fields: [
        {
          key: "accountInfo",
          label: "نام کاربر",
          sortable: true,
          class: "text-right",
        },
        {
          key: "holderName",
          label: "نام ثبت شده شبا",
          sortable: true,
          class: "text-right",
        },
        {
          key: "iban",
          label: "شماره  شبا",
          sortable: true,
          class: "text-right",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-right",
        },
        { key: "actions", label: "عملیات", class: "text-right" },
      ],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      http.get(`/BankShebas/pending`,)
        .then((response) => {
          this.results = response.data;
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    verifySheba(id, userId) {
     http.put("/BankShebas/" + id + "/account/" + userId + "/approve",)
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },

    rejectSheba(id, userId) {
     http.put( "/BankShebas/" + id + "/account/" + userId + "/reject",)
        .then(() => {
          this.getData();
        })
        .catch((err) => {
          if (err.response) {
          }
        });
    },
  },
};
</script>

<style lang="scss">
.v-users-iban {
  padding: 16px;
}
</style>
